export const importFromCsv = {
  title: 'CSV Import customer',
  importSuccessfully: 'Import customer successfully!',
  importFailed: 'Import customer failed!',
}
